export const STORE_ID = {
  FRANCE: '11652',
  LUXEMBOURG: '11657',
  BELGIQUE: '11151',
  DEUTSCHLAND: '11152',
  OSTERREICH: '11658',
  SUISSE: '11662',
  SCHWEIZ: '11660',
  UNITED_KINGDOM: '11663',
  IRELAND: '11654',
  ITALIA: '11655',
  ESPANA: '11651',
  PORTUGAL: '11659',
  USA: '12151',
  SINGAPORE: '11661',
  HONG_KONG: '11653',
  NETHERLANDS: '12001',
  GREECE: '12000',
  COM: '12004',
  REP_TCHEQUE: '12008'
};

export const STORE_ID_DEFAULT = STORE_ID.FRANCE;
